import { useWebBooking } from "api/api-hooks/use-web-booking";
import { useBookingStateContext } from "hooks/use-booking-state";

/**
 * The party size availability was computed for: the guest's own selection, falling back to an
 * existing booking's. Mirrors how useAvailableTimes resolves it, so anything derived from those
 * times is read against the same party size that produced them — adding an activity to an existing
 * booking arrives with the count on the booking and nothing in state.
 */
export function useResolvedGuests(): number | null {
    const { guests } = useBookingStateContext();
    const { data: booking } = useWebBooking();

    return guests ?? booking?.guests ?? null;
}
